import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { TopSectionHead } from '@/components/modules/pages/top/typography/head/TopSectionHead';
export const TopThemeBase = (props) => {
    const { children, className = '' } = props;
    return (_jsxs("div", Object.assign({ className: clsx('bg-blue-gray-75', 'pt-40 md:pt-[69px] pb-64 md:pb-80', className) }, { children: [_jsx(TopSectionHead, { children: "\u3054\u76F8\u8AC7\u9802\u3051\u308B\u30C6\u30FC\u30DE" }), children] })));
};
